import { useEffect, useMemo, useState } from 'react';

/**
 * Client-side table pagination — same behaviour as StudentList / PaginationFooter.
 * @param {Array} items - full row list
 * @param {unknown} resetKey - when this changes, page resets to 0 (e.g. filter string or report id)
 */
export default function useClientPagination(items, resetKey = null) {
    const [page, setPage] = useState(0);
    const [size, setSize] = useState(10);
    const list = items ?? [];
    const total = list.length;
    const totalPages = Math.max(1, Math.ceil(total / size) || 1);

    useEffect(() => {
        setPage(0);
    }, [resetKey, total]);

    useEffect(() => {
        if (page > totalPages - 1) {
            setPage(Math.max(0, totalPages - 1));
        }
    }, [page, totalPages]);

    const pageItems = useMemo(
        () => list.slice(page * size, page * size + size),
        [list, page, size]
    );

    const setSizeAndReset = (nextSize) => {
        setSize(nextSize);
        setPage(0);
    };

    return {
        page,
        size,
        total,
        pageItems,
        setPage,
        setSize: setSizeAndReset,
    };
}
